import ViewDragon from './ViewDragon';
export default ViewDragon;
